<template>
    <div class="Content" v-if="!IsMobile">
        <div class="leftContent">
            <span>报修语音</span>
        </div>
        <div class="rightContent" v-if="IsShowRecordImg">
            <span
                v-if="DurationShow">语音时长:{{`${AuditDurationMinute<10?('0'+AuditDurationMinute):AuditDurationMinute}:${AuditDurationSecond<10?('0'+AuditDurationSecond):AuditDurationSecond}`}}</span>
            <img :src="require(isVoice?'../../assets/img/AudioOff.png':'../../assets/img/AudioOn.png')"
                @click="!isVoice?readvioce():onEndVoice()" />
        </div>
        <div class="AudioHistry" :key='AudioUrl'>
            <audio controls="controls">
                <source type="audio/wav" :src="AudioUrl" />
            </audio>
        </div>
    </div>
</template>
<script>
    import {
        LoadJurisdiction
    } from '../../../tool/permission.js'
    import {
        PresentType
    } from '../../../config/index.js'
    let Ios_recorder = null;
    export default {
        props: {
            AudioExternal: {
                type: String,
                default: null,
            },
            IsShowRecordImg: {
                type: Boolean,
                default: false
            }
        },
        components: {},
        name: 'AudioDefault',
        data() {
            return {
                AudioState: true, //Ios对于麦克风权限
                Timer: null, //计时器
                isVoice: false, //是否开启录音
                AuditDurationMinute: 0, //语音时长(时)
                AuditDurationSecond: 0, //语音时长(分)
                DurationShow: false, //是否展示语音时长
                AudioPlay: this.AudioExternal ? true : false, //是否展示播放录音
                AudioUrl: this.AudioExternal ? this.AudioExternal : '', //语音地址
                IsMobile: PresentType, //是否手机端
                Jurisdiction: { //权限验证
                    Android: 'android.permission.RECORD_AUDIO',
                    Ios: 'record',
                    Message: '请在权限管理赋予APP麦克风录音权限',
                },
            };
        },
        beforeDestroy() {
            clearInterval(this.Timer);
        },
        mounted() {},
        methods: {
            readvioce() {
                LoadJurisdiction(this.Jurisdiction).then(() => { //权限验证
                    let _this = this;
                    Ios_recorder = plus.audio.getRecorder();
                    _this.AudioPlay = false;
                    _this.isVoice = !_this.isVoice;
                    _this.DurationShow = !_this.DurationShow;
                    if (plus.os.name == 'Android') {
                        this.Timer = setInterval(() => {
                            this.AuditDurationSecond += 1;
                            if (this.AuditDurationSecond == 59) {
                                this.AuditDurationMinute += 1;
                                this.AuditDurationSecond = 0;
                            }
                        }, 1000)
                    } else this.LoadAudioJurisdiction()
                    Ios_recorder.record({
                        samplerate: '44100',
                        filename: "_doc/audio/"
                    }, function(recordFile) {
                        _this.GetBase(recordFile).then(res => {
                            _this.$post('api/RepairHandle/PostFormData', {
                                Base64: res,
                                WXDH: _this.$getRandomNumber(16)
                            }).then(result => {
                                if (result.Status) {
                                    _this.$emit('AudioAddress', result.Code);
                                    _this.AudioPlay = true;
                                    _this.AudioUrl = result.Msg;
                                    _this.DurationShow = false;
                                } else {
                                    _this.$Toast('当前音频保存失败,请稍后再试!');
                                }
                            }).catch(err => {
                                _this.$Toast('语音文件保存失败!');
                            })
                        }).catch(err => {
                            _this.$Toast('语音处理失败，请联系管理员进行处理!');
                        });
                    }, function(e) {
                        _this.$Toast({
                            message: "此设备无麦克风或权限不足（请在权限管理赋予APP麦克风录音权限）" + e.message,
                            duration: 3000
                        });
                    });
                })
            },
            onEndVoice() { //结束录音方法调用
                clearInterval(this.Timer);
                this.AuditDurationMinute = 0;
                this.AuditDurationSecond = 0;
                this.isVoice = !this.isVoice;
                this.DurationShow = !this.DurationShow;
                Ios_recorder.stop();
            },
            GetBase(recordFile) {
                return new Promise((resolve, reject) => {
                    plus.io.resolveLocalFileSystemURL(recordFile, function(entry) {
                        entry.file(function(file) { //读取为File对象
                            const fileReader = new plus.io.FileReader();
                            fileReader.onloadend = (e) => { //约定返回wavBase64
                                resolve(e.target.result)
                            };
                            fileReader.readAsDataURL(file);
                            fileReader.onerror = () => {
                                reject(new Error('blobToBase64 error'));
                            };
                        });
                    }, function(e) {
                        alert("Resolve file URL failed: " + e.message);
                    });
                });
            },
            LoadAudioJurisdiction() { //反复询问麦克风权限
                var avaudiosession = plus.ios.import("AVAudioSession");
                var avaudio = avaudiosession.sharedInstance();
                var Timmer = setInterval(() => { //每0.3秒探查一次麦克风权限
                    var permissionStatus = avaudio.recordPermission();
                    if (permissionStatus == 1684369017 || permissionStatus == 1970168948) {} else {
                        this.Timer = setInterval(() => {
                            this.AuditDurationSecond += 1;
                            if (this.AuditDurationSecond == 59) {
                                this.AuditDurationMinute += 1;
                                this.AuditDurationSecond = 0;
                            }
                        }, 1000);
                        clearInterval(Timmer);
                        plus.ios.deleteObject(avaudiosession);
                    }
                }, 300);
            }
        },
        watch: {
            AudioExternal(value) {
                this.AudioUrl = value;
                this.AudioPlay = true;
            }
        }
    };
</script>

<style scoped lang="scss">
    .Content {
        background-color: #fff;
        border-radius: 1.6vw;
        padding: 0 4.8vw;
        box-sizing: border-box;

        .leftContent {
            span {
                margin-bottom: 1vw;
                color: #14171a;
                font-size: 4.533vw;
                font-weight: bold;
            }

            width: 35%;
            display: inline-block;
        }

        .rightContent {
            text-align: right;
            display: inline-block;

            img {
                width: 2rem;
                height: 2rem;
                position: relative;
                top: 15px;
                right: 0;
            }

            width: 63%;
        }

        .AudioHistry {
            margin-top: 20px;

            audio {
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Audio/AudioDefault.vue